// extracted by mini-css-extract-plugin
module.exports = {"bigYieldTarget":"YieldTarget_bigYieldTarget__4TaV_"};